import { useCallback } from "react";
import useCurrentModal from "@/common/hooks/useCurrentModal";
import useCurrentTrack from "@/common/hooks/useCurrentTrack.ts";
import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import useAudioEditorVisible from "@/common/hooks/preferences/useAudioEditorVisible.ts";

export const useKeyboardShortcutEditTrack = () => {
  const currentExplorerItem = useCurrentExplorerItem();
  const [currentModal] = useCurrentModal();
  const [editorIsOpen, setEditorIsOpen] = useAudioEditorVisible()
  const currentTrack = useCurrentTrack();

  const toggleEditTrack = useCallback(() => {
    if (!currentExplorerItem) return;

    setEditorIsOpen(!editorIsOpen)
  }, [
    currentExplorerItem,
    editorIsOpen,
    setEditorIsOpen
  ]);

  useKeyboardListener((event) => {
    if (currentModal.type || !currentTrack?.id) return;

    if (event.key === "e" && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      toggleEditTrack();
    }
  });

  return null;
};
